<!-- Projected toolbar (feed-results / story-posts / related-posts sort) -->
<ng-content select="[postListToolbar]"></ng-content>
<!-- Advanced-search builder (feed only); independent of the toolbar above -->
@if (showAdvancedSearch) {
  <div class="advanced-search-component">
    <app-advanced-search
      [feed]="feed"
      [searchQuery]="feedSearchQuery"
    ></app-advanced-search>
  </div>
}
@if (showPagination) {
  <app-post-cards-tools
    [viewMode]="viewMode"
    [toolsClass]="'footer'"
    [loading]="loading"
    [externalCurrentPage]="currentPage"
    [externalItemsPerPage]="itemsPerPage"
    [externalTotalItemsCount]="totalItemsCount"
    (externalPageChange)="onPageChanged($event)"
    (externalItemsPerPageChange)="onItemsPerPageChanged($event)"
  ></app-post-cards-tools>
}
<ng-container>
  @if (!loading && postsListCount === 0) {
    <div class="app-loading-wrapper">
      <div class="no-posts-message">
        {{ "feed.title.no-available-posts" | translate }}
      </div>
    </div>
  }
  @if (viewMode === "default" || viewMode === "threads") {
    <div class="card-container posts" #cardContainer>
      @if (loading) {
        <app-loading-card
          type="post"
          [count]="skeletonCount"
          [animationEnabled]="true"
        ></app-loading-card>
      }
      @for (post of posts; track postTrackByFn(i, post); let i = $index) {
        <!-- In default mode: hide parent/context posts. In threads mode: show all. -->
        @if (
          !post.is_collapsed && (viewMode === "threads" || !post.is_parent)
        ) {
          <app-post-card
            #postCardCmp
            [post]="post"
            [user]="user"
            [viewMode]="'default'"
            [showThreads]="viewMode === 'threads'"
            [allowRelatedPosts]="true"
            [feed]="feed"
            [viewConfig]="viewConfig"
            [feedId]="$safeNavigationMigration(feed?.id)"
            [highlighted]="postScrollMode && currentPostIndex === i"
            [attr.id]="'post-' + i"
            [attr.data-post-id]="post.id"
            (togglePostDetails)="onTogglePostDetails($event, i)"
            [class.active-post]="
              post.id == selectedPostId && feed?.views?.includes('details')
            "
            [currentLanguage]="currentLanguage"
            [timeShown]="timeShown"
            [loadingAlgorithmPostIds]="loadingAlgorithmPostIds"
            [appliedAlgorithmPostIds]="appliedAlgorithmPostIds"
            [disableTools]="disableTools"
            [isStoryMode]="isStoryMode"
            [selectable]="selectable"
            [customTogglePostSelect]="
              customTogglePostSelect ? customTogglePostSelect(post) : null
            "
            [customRemovePost]="customRemovePost"
            (requestToggleThread)="onRequestToggleThread($event)"
          ></app-post-card>
        }
      }
    </div>
  }

  @if (viewMode === "gallery") {
    <div #masonryContainer class="card-container posts-gallery">
      @if (loading) {
        <app-loading-card
          type="post-gallery"
          [count]="skeletonCount"
        ></app-loading-card>
      }
      @for (post of posts; track postTrackByFn(i, post); let i = $index) {
        <div #masonryItems [ngClass]="{ details: postDetailsList[post.id] }">
          <app-post-card
            [post]="post"
            [user]="user"
            [viewConfig]="viewConfig"
            (imageLoaded)="onImageLoaded()"
            (togglePostDetails)="onTogglePostDetails($event, i)"
            [viewMode]="'gallery'"
            [feedId]="$safeNavigationMigration(feed?.id)"
            [class.active-post]="
              post.id == selectedPostId && feed?.views?.includes('details')
            "
            [currentLanguage]="currentLanguage"
            [timeShown]="timeShown"
            [loadingAlgorithmPostIds]="loadingAlgorithmPostIds"
            [appliedAlgorithmPostIds]="appliedAlgorithmPostIds"
            [disableTools]="disableTools"
            [selectable]="selectable"
            [customTogglePostSelect]="
              customTogglePostSelect ? customTogglePostSelect(post) : null
            "
            [customRemovePost]="customRemovePost"
          ></app-post-card>
        </div>
      }
    </div>
  }
</ng-container>
